import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [
  {
    path: "",
    loadChildren: ()=>import('./landing/landing.module').then(m=>m.LandingModule)
  },
  {
    path: "",
    loadChildren: ()=>import('./pricing/pricing.module').then(m=>m.PricingModule)
  },
  {
    path: "",
    loadChildren: ()=>import('./testimonial/testimonial.module').then(m=>m.TestimonialModule)
  },
  {
    path: "",
    loadChildren: ()=>import('./contact/contact.module').then(m=>m.ContactModule)
  },
  {
    path: "",
    loadChildren: ()=>import('./faq/faq.module').then(m=>m.FaqModule)
  },
  {
    path: "",
    loadChildren: ()=>import('./blog/blog.module').then(m=>m.BlogModule)
  },
  {
    path: "",
    loadChildren: ()=>import('./static/static.module').then(m=>m.StaticModule)
  },
  {
    path: "",
    loadChildren: ()=>import('./booking/booking.module').then(m=>m.BookingModule)
  },
  {
    path: "**",
    redirectTo: "/"
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
